import styled from 'styled-components';

const Container = styled.div`
  max-width: 68rem;
  margin-left: auto;
  margin-right: auto;
`;

export default Container;
